import React, { Component } from 'react';
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { Card, Button, Input } from '../../ui';
import { 
  isAlreadyLogged, 
  clientMailFromToken
} from '../../../api';

import LoginWrapper from './Login.style';
import {
  setClientValue,
  increaseStepByOne,
  decreaseStepByOne,
  showError,
  setStepInnerPage
} from "../../../actions";
import { client } from "../../../operations";
import { validateEmail } from '../../../helpers';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconPass from '../../../assets/icons/icon-pass.svg';

import Loader from '../Loader';
import Text from '../Form/Text';

const { apps } = require('../../../ecosystem.config.js');

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
      validation: false,
      password: ''
    };

    const {
      actualPos, prevPos,
      goForward, goBack,
      getClientByMail
    } = this.props;

    //if(actualPos > prevPos) goForward();
    if(actualPos < prevPos && actualPos > 0) { goBack(); }
    if(!(actualPos < prevPos) && isAlreadyLogged()) { 
      getClientByMail(clientMailFromToken());
    }
    
    this.onChange = this.onChange.bind(this);
    this.handleOnLoginClick = this.handleOnLoginClick.bind(this);
    this.handleOnRegisterClick = this.handleOnRegisterClick.bind(this);
    this.handleOnForgotPasswordClick = this.handleOnForgotPasswordClick.bind(this);
  }

  componentDidMount() {
    const { email, setClientValue } = this.props;
    const { validation, password } = this.state;
    const { reCaptcha } = apps[0];

    this.checkContinueState(this.state,
      email != '' &&
      validateEmail(email) &&
      password != '' &&
      ((validation && reCaptcha.enabled) || !reCaptcha.enabled)
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const { email } = this.props;
    const { validation, password } = this.state;
    const { reCaptcha } = apps[0];
    this.checkContinueState(prevState,
      email != '' &&
      validateEmail(email) &&
      password != '' &&
      ((validation && reCaptcha.enabled) || !reCaptcha.enabled)
    )
  }

  checkContinueState(prevState, condition) {
    if (condition) {
      if (!prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState.continue) this.setState({ continue: false });
    }
  }

  handleOnRegisterClick() {
    const { setStepInnerPage } = this.props;
    setStepInnerPage('register');
  };

  handleOnForgotPasswordClick() {
    const { setStepInnerPage } = this.props;
    setStepInnerPage('resetPassword');
  };

  handleOnLoginClick() {
    const { continue: toContinue, password } = this.state;
    const { onLoginClick, showErrorBorder } = this.props;
    if (toContinue)
      onLoginClick(password);
    else
      showErrorBorder();
  };

  getLoginButton() {
    const { continue: toContinue } = this.state;
    return (
      <Button disabled={!toContinue} onClick={this.handleOnLoginClick}>
        Ingresar
      </Button>
    );
  }

  getRegisterButton() {
    return (
      <Button plain onClick={this.handleOnRegisterClick} className="Login-link">
        Registrarme
      </Button>
    );
  }

  onChange() {
    var that = this;
    return new Promise(function change(resolve, reject) {
      that.setState({ validation: true });
      that.checkContinueState({continue: true}, (that.state));
      resolve();
    });
  }

  render() {

    const { 
      email, errorMsg,
      loading, setClientValue,
    } = this.props;
    const { validation, password } = this.state;
    const { reCaptcha } = apps[0];

    return (
      <LoginWrapper>
        { loading ? <Loader /> :
          <div>
            <Card.Header>Login</Card.Header>
            <Text className="Text-question" style={{ marginBottom: '10px' }}>
              Si ya sos cliente SURA ingresá tu email y contraseña
            </Text>

            <div className="inputs-container">
              <Input
                id="email"
                name="email"
                placeholder="Email"
                maxLength="50"
                type="email"
                value={email}
                onChange={(event) => { setClientValue('email', event.target.value); }}
                leftIcon={iconEmail}
                showAlert={!validation && !validateEmail(email)}
              />
              <Input
                id="password"
                name="password"
                placeholder="Contraseña"
                maxLength="50"
                type="password"
                value={password}
                onChange={(event) => { this.setState({ password: event.target.value }); }}
                leftIcon={iconPass}
                showAlert={!validation && !password}
              />

              {reCaptcha.enabled &&
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    sitekey={reCaptcha.sitekey}
                    onChange={this.onChange}/>
                </div>
              }

              <div style={{ fontSize: '0.9em', marginBottom: 15, 'textAlign': 'center' }}>
                <Button
                  plain
                  onClick={this.handleOnForgotPasswordClick}
                  style={{ float: 'right', textTransform: 'capitalize', fontFamily: 'FSJoey' }}
                >
                  Olvidé mi contraseña
                </Button>
              </div>
            </div>

            <div className="Login-buttonsContainer">
              {this.getLoginButton()}
              {this.getRegisterButton()}
            </div>

            {errorMsg && (
              <div className="centeredContinueButton">
                <Text className="Text-error"> {errorMsg} </Text>
              </div>
            )}
          </div>
        }
      </LoginWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.steps.isLoading,
    errorMsg: state.client.errorMessage,
    email: state.client.email,
    actualPos: state.steps.selectedStep.pos,
    prevPos: state.steps.prevStep.pos
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoginClick: (password) => {
      dispatch(setClientValue('errorMessage', ''));
      dispatch(client.login(password));
    },
    getClientByMail: (email) => {
      dispatch(client.getClientByMail(email));
    },
    setClientValue: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    goForward: () => {
      dispatch(increaseStepByOne());
    },
    goBack: () => {
      dispatch(decreaseStepByOne());
    },
    showErrorBorder: () => {
      dispatch(showError(true));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);